import {GET_OFFRE} from "../actions/types";


  const initialState = {
    offres:[]
  };
  export default function offre(state = initialState, action) {
    switch (action.type) {
      case GET_OFFRE:
        return {
          ...state,
         offres:action.payload
        };
      default:
        return state;
    }
  }
